export default __webpack_public_path__ + "images/83aae1739ef4cd3658bf0fe5ffa20018-smith-bormann.png";